import React, { Component as Component } from 'react';

export default function Header({ title }) {
	return <div className="modal-header">
		<button type="button" className="close" data-dismiss="modal">
			<i className="fa fa-times"></i>
		</button>
		<h4 className="modal-title">{ title }</h4>
	</div>
}


// WEBPACK FOOTER //
// ./src/modules/utils/Header.js